import React from 'react'
import { checkUrlForDisplay, checkUrlForLink } from '../utils';
import { renderDemographics, renderLogoImages } from './finder-utils';
import { ACCESS_FOR_ALL_ABILITIES_PLAY } from './data/Constants'
import ContactDetail from './ContactDetail'

/**
 * Club Details component
 * 
 * This component displays extended details about a club, usually after a user has clicked on a
 * map marker or club teaser component.
 * 
 * This component has the following properties
 * club: the club for which we are displaying details
 * showRegistrationDeactivatedDialog: A callback function to display the registration deactivated dialog in the parent component
 * onCloseClicked: a callback function to call when this component is closed
 */
export default class ClubDetail extends React.Component {
  constructor(props){
    super(props)
  
    this.state = {
      registerUrl: props.club.registerUrl,
      isLoading: false
    }
  }

  handlePlayerRegistrationClick(e){
    e.preventDefault();
    if (Number(this.props.club.details.intDeactivate) ){
      this.props.showRegistrationDeactivatedModal()
    } else {
      this.setState({isLoading: true}, () => {
        let result = this.props.club.registerFunc.determineRegistrationUrl()
        if (result){
          result.then(()=> {this.setState({isLoading: false})})
        } else {
          this.setState({isLoading: false})
        }
      });
    }
  }

  render(){
    let club = this.props.club;
    let allAbilities = club.details.inclusions && club.details.inclusions.indexOf(ACCESS_FOR_ALL_ABILITIES_PLAY) >= 0;    

    return (
      <div className="club-details relative" id="club-details">
        
        <div className="club-description-playhq">
          <div className="club-description-header flex">
            <div className="club-description-title">
              <h3 className="club-heading">{club.name}</h3>
            </div>
            <a className="close-club-details" onClick={() => this.props.onCloseClicked(club)} tabIndex="0">
              <svg width="20" height="20" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg">
                <title>Close</title><g id="Symbols" fill="none"><g id="Club-Details-360" fill="#000000"><g id="Icon/Close"><g id="Group-2"><path id="Rectangle-8" d="M12.657-.07l1.414 1.413L1.346 14.07-.07 12.658z"/><path id="Rectangle-8" d="M.038 1.58L1.452.163l12.728 12.73-1.414 1.413z"/></g></g></g></g>
              </svg>
            </a>
          </div>
          {club.distance > 0 &&
            <div className="club-distance">
              {club.distance}KM
            </div>
          }
          <p className="club-description-inclusion">
             {club.details.demographics &&
              renderDemographics(club.details.demographics)
              }
              
              {/* {allAbilities &&
                <span className="block">All Abilities</span>
              } */}
          </p>
          <div className="club-format-logos flex">
              {renderLogoImages(club.details.formats)}
          </div>
          <div className="club-details-body">
            <div className="center club-register-buttons">
                <a onClick={(e) => this.handlePlayerRegistrationClick(e)} className="btn btn-map btn-mobile-sticky btn-full-width" tabIndex="0">
                  Register <span className="icon icon-chevron-right"></span>
                </a>
            </div>
            
          {club.details.address && 
            <div className="club-details-section">
              <h4>Where</h4>
              {club.details.address.line1 &&
                <p>{club.details.address.line1}</p>
              }
              {club.details.address.suburb &&
                <p>{club.details.address.suburb} 
                {club.details.address.postcode &&
                  <span>&nbsp;{club.details.address.postcode}</span>
                }
                </p>
              }
              {club.details.address.state &&
                <p>{club.details.address.state}</p>
              }
            </div>
          }
           { console.log("contact length",club.details.contactNumber.length) }
           { console.log("contact",club.details.contactNumber) }
          {club.details.contactNumber !='N/A'  && club.details.contactNumber.length != 0 && club.details.websiteUrl != null && club.details.email != null &&
          // {(club.details.contactNumber || club.details.websiteUrl || club.details.email) &&
          
            <div className="club-details-section test">
              <h4>Contact</h4>
              {club.details.websiteUrl &&
                <p><a href={checkUrlForLink(club.details.websiteUrl)} target="_blank" className="contact-link contact-web">{checkUrlForDisplay(club.details.websiteUrl)}</a></p>
              }
              {club.details.email &&
                <p><a href={'mailto:' + club.details.email} className="contact-link contact-email">{club.details.email}</a></p>
              }
              {club.details.contactNumber != 'N/A' &&
                <p><a href={'tel:' + club.details.contactNumber} className="contact-link contact-phone">{club.details.contactNumber}</a></p>
              }
              
            </div>
          }
          {club.details.contacts != null && club.details.contacts.length > 0 &&
            club.details.contacts.map((contact, index) =>
            <ContactDetail
              key={index}
              contact={contact}
            />
          )
          }
          
          </div>
        </div>
      </div>
    )
  }
}
